module.exports = __webpack_public_path__ + "img/New Project (9).f6b6e14a.png";